export const removeDuplicatedAlerts = (alerts: IPatientAlerts[]) => {
  const uniqueAlerts: IPatientAlerts[] = [];
  const uniqueIds: string[] = [];
  if (!alerts) return uniqueAlerts;

  alerts.map((alert) => {
    if (!uniqueIds.includes(alert.alert_id)) {
      uniqueIds.push(alert.alert_id);
      uniqueAlerts.push(alert);
    }
  });
  return uniqueAlerts;
};
